import { css } from 'styled-components';

export default css`
    .sb2wicon {
        font-size: 2.4rem;
        margin-right: .5rem;
    }
`;
